// extracted by mini-css-extract-plugin
module.exports = {"footer":"AppFooter_footer__1Z3SA","footerInside":"AppFooter_footerInside__3WAl8"};